import './Login.css';
import Form, { FormProps } from '..';
import useStore from '../../Hooks/useStore';
import { ChangeEvent, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

interface FormLoginProps extends FormProps {}

export default function FormLogin({
  children,
  className = '',
  ...rest
}: FormLoginProps) {
  const [getters, setters] = useStore();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const {
    form: { getForm },
  } = getters;

  const {
    auth: { login },
    form: { setForm },
    modal: { openSingleModal },
  } = setters;

  const [loading, setLoading] = useState(false);

  const onSubmit = (e: any) => {
    e.preventDefault();
    setLoading(true);
    login()
      .then(() => {
        setLoading(false);
        enqueueSnackbar('Login realizado com sucesso', {
          variant: 'success',
        });
        navigate(`/tools`);
      })
      .catch(() => {
        setLoading(false);
        enqueueSnackbar('Falha ao realizar login', {
          variant: 'error',
        });
      });
  };

  function setField<T extends FlattenKeys<DataForm>>(field: T) {
    return (e: ChangeEvent<HTMLInputElement>) => {
      setForm<T>(field, e.target.value as DeepType<DataForm, T>);
    };
  }

  return (
    <Form className={`form-login ${className}`} onSubmit={onSubmit} {...rest}>
      {children}
      <span className="label-input-login">Usuario</span>
      <Form.Field
        activeLabelColor="white"
        className="email"
        value={getForm('login.email')}
        onChange={setField('login.email')}
      />
      <span className="label-input-login">Senha</span>
      <Form.Input.Password
        activeLabelColor="white"
        className="password"
        errorMessage={false}
        value={getForm('login.password')}
        onChange={setField('login.password')}
      />

      <Form.Button type="submit" disabled={loading} loading={loading}>
        Entrar
      </Form.Button>

      <Form.Link
        className="form-link"
        onClick={() => {
          openSingleModal('recoverPassword');
        }}
      >
        Esqueci minha senha
      </Form.Link>
    </Form>
  );
}
